import { z } from 'zod';

// TODO: refine after Data Structure doc review
// An Issue is a tracked pattern across feedback: a recurring bug, request, or theme.

export const IssueStatusSchema = z.enum([
  'open',
  'investigating',
  'planned',
  'in_progress',
  'resolved',
  'wont_fix',
  'duplicate',
]);
export type IssueStatus = z.infer<typeof IssueStatusSchema>;

export const IssueSchema = z.object({
  id: z.string().uuid(),
  gameId: z.string().uuid(),
  title: z.string().min(1),
  description: z.string().nullable(),
  status: IssueStatusSchema,
  severity: z.enum(['blocker', 'major', 'minor', 'cosmetic']).nullable(),
  feedbackCount: z.number().int().nonnegative(),
  firstSeenAt: z.string().datetime({ offset: true }).nullable(),
  lastSeenAt: z.string().datetime({ offset: true }).nullable(),
  createdByUserId: z.string().uuid().nullable(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type Issue = z.infer<typeof IssueSchema>;
